export enum AmplitudeEvent {
	ChangeFilter = 'Change Feedback Filter',
	EditFeedbackDraftButtonClicked = 'Edit Feedback Draft Button Clicked',
	GiveFromRecognition = 'Give Feedback From Recognition',
	ManageUnrequestedFeedbackModalClosed = 'Manage Unrequested Feedback Modal Closed',
	ManageUnrequestedFeedbackModalViewed = 'Manage Unrequested Feedback Modal Viewed',
	Navigate = 'Navigate to Feedback',
	RequestFeedback = 'Click Request Feedback',
	RequestFeedbackModalOpened = 'Request Feedback Modal Opened',
	RequestFeedbackDraftSaved = 'Request Feedback Draft Saved',
	RequestFromRecognition = 'Request Feedback From Recognition',
	DraftFromTemplateCreated = 'Template-Based Draft Feedback Created',
	RespondToRequest = 'Click Respond to Feedback Request',
	SendRequest = 'Click Send Feedback Request',
	SendResponse = 'Click Send Feedback Response',
	UnsolicitedCreated = 'unsolicited-feedback-created',
	UnsolicitedFeedbackAddResponse = 'Unsolicited Feedback Add Response Clicked',
	UnsolicitedFeedbackDraftSaved = 'Unsolicited Feedback Draft Saved',
	UnsolicitedFeedbackModalOpened = 'Unsolicited Feedback Modal Opened',
	UnsolicitedFeedbackSent = 'Unsolicited Feedback Sent',
	SolicitedFeedbackDraftSaved = 'Solicited Feedback Draft Saved',
	UpdateRequest = 'Click Edit Feedback Request',
}
